import { useEffect, type CSSProperties, type ReactNode } from 'react';

const BACKDROP: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 80,
  background: 'rgba(10,10,12,.42)',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  padding: 'max(24px, 6vh) 16px 24px',
  overflowY: 'auto',
};

/**
 * Centered modal: scrim backdrop (click or Escape to close) + a flat card with
 * a close button. Children render the modal's own header and body. Shared by
 * the Profile and Admin panels.
 */
export function ModalShell({ onClose, maxWidth = 460, children }: { onClose: () => void; maxWidth?: number; children: ReactNode }) {
  useEffect(() => {
    const k = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [onClose]);

  return (
    <div onClick={onClose} className="he-fadein" style={BACKDROP}>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', width: '100%', maxWidth, background: 'var(--bg-1)', borderRadius: 22, boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="he-press"
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            zIndex: 1,
            width: 32,
            height: 32,
            borderRadius: 999,
            border: 'none',
            background: 'var(--bg-3)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="var(--fg-2)" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        {children}
      </div>
    </div>
  );
}
